import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const [hover, setHover] = useState(false);
  const hasSecond = product.images.length > 1;

  return (
    <div
      className="group"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-[3/4] bg-[#ece4d6] overflow-hidden">
          <img
            src={product.images[0]}
            alt={product.name}
            className={`absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out ${
              hover && hasSecond ? "opacity-0 scale-105" : "opacity-100 scale-100"
            }`}
          />
          {hasSecond && (
            <img
              src={product.images[1]}
              alt={product.name}
              className={`absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out ${
                hover ? "opacity-100 scale-105" : "opacity-0 scale-100"
              }`}
            />
          )}

          {/* Badge */}
          {product.badge && (
            <span className="absolute top-3 left-3 bg-gold text-[#14110c] text-[9px] tracking-[0.2em] uppercase px-3 py-1 font-medium">
              {product.badge}
            </span>
          )}
          {product.oldPrice && (
            <span className="absolute top-3 right-3 bg-[#ffffff]/80 text-gold border border-gold text-[9px] tracking-[0.15em] uppercase px-2 py-1">
              Sale
            </span>
          )}

          {/* Quick add */}
          <div
            className={`absolute inset-x-0 bottom-0 p-3 transition-all duration-500 ${
              hover ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
            }`}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                addItem(product);
              }}
              className="w-full bg-[#ffffff]/90 backdrop-blur border border-gold text-gold text-[11px] tracking-[0.2em] uppercase py-3 hover:bg-gold hover:text-[#14110c] transition-colors"
            >
              In den Warenkorb
            </button>
          </div>
        </div>
      </Link>

      {/* Info */}
      <div className="pt-4 text-center">
        <p className="text-[10px] tracking-[0.25em] uppercase text-gold mb-1">
          {product.family}
        </p>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-serif text-xl text-[#17140f] leading-tight hover:text-gold transition-colors">
            {product.name}
          </h3>
        </Link>
        <p className="text-[#8d8779] text-xs mt-1">{product.subtitle}</p>
        <div className="flex items-center justify-center gap-1 mt-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              size={12}
              className={
                i < Math.round(product.rating)
                  ? "fill-gold text-gold"
                  : "text-[#d6cebf]"
              }
            />
          ))}
          <span className="text-[#8d8779] text-xs ml-1">({product.reviews})</span>
        </div>
        <div className="flex items-center justify-center gap-2 mt-2">
          {product.oldPrice && (
            <span className="text-[#8d8779] text-sm line-through">
              €{product.oldPrice.toFixed(2)}
            </span>
          )}
          <span className="text-[#17140f] text-sm">€{product.price.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
